import { getHostName } from "./config";
import { save, read } from "./Storage";
import md5 from "md5";



export const API_PREFIX = getHostName();

export function setAccessToken(token) {
  window.accessToken = token;
  save('accessToken', token);
}

export function getAccessToken() {
  if(!window.accessToken){
    window.accessToken = read('accessToken');
  }
  return window.accessToken;
}

export function serverHost() {
  return API_PREFIX;
}

export function generateUrl(apiName, params = {}, isPost = false) {
  let url = apiName.indexOf('http')>=0 ? apiName : serverHost() + '/api/'  + apiName ;
  if (!isPost) {
    for (let key in params) {
      let char = url.indexOf('?') === -1 ? '?' : '&';
      if (params[key] !== undefined)
        url += char + key + '=' + params[key];
    }
  }
  return url;
};

export function apiGet(a, params, types) {
  return (dispatch, getState) => {
    return requestImpl(dispatch, a, params, types);
  };
}

export function apiPost(a, params, types) {
  return (dispatch, getState) => {
    return requestImpl(dispatch, a, params, types, true);
  };
}

function getSign(params) {
  let manageKey = 'TDwhwuY4oORU7ldr';
  let timestamp = Date.now();
  let newParams = {...params, manageKey, timestamp};
  let paramsStr = '';
  for (let key in newParams) {
    if (newParams[key] !== undefined) {
      paramsStr += key + newParams[key];
    }
  }
  let sign = md5(paramsStr);
  return {
    manageId : 100001,
    timestamp,
    sign
  }
}

function requestImpl(dispatch, a, params, types, isPost = false) {
  let token = getAccessToken();
  let signObj = getSign(params);
  // console.warn('accessToken is ', token);
  let rp = {
    method: 'GET',
    // credentials: 'include', 
    headers: {
      ...signObj
    },
  };
  if (isPost) {
    rp = {
      method: 'POST',
      // credentials: 'include', 
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization' : token,
        ...signObj
      },
      body: JSON.stringify(params)
    }
  }

  dispatch({ type: types[0] , payload:{params}});
  let url = a.indexOf('http') >= 0 ? a : generateUrl(a, params, isPost);
  return fetch(url, rp)
    .then((response) => response.json())
    .then((json) => {
      //ret == 0表示返回正常, -1标识请求失败
      const payload = { ...json };
      payload.params = params;
      // console.log('requestImpl  response : ' + JSON.stringify(json));
      if (json.code !== 1) {
        dispatch({ type: types[2], payload });
      } else {
        dispatch({ type: types[1], payload });
      }
    })
    .catch((err) => {
      // console.log('requestImpl  catch error : ' + JSON.stringify(err) + ', ' + err.message);
      if (err instanceof TypeError) {
        dispatch({
          type: types[2],
          payload: {errmsg : '网络错误', params}
        });
      }
      else if (err instanceof Error) {
        dispatch({
          type: types[2],
          payload: {errmsg : err.message, params}
        });
      }
      else {
        dispatch({
          type: types[2],
          payload: {errmsg : err.message, params}
        });
      }
    });
}

